import { useEffect } from "react";
import { createPortal } from "react-dom";

import styles from "./BottomSheet.module.css";

const BottomSheet = ({

    open,

    title,

    children,

    onClose,

}) => {

    useEffect(() => {

        if (!open) return;

        const handleKeyDown = (event) => {

            if (event.key === "Escape") {

                onClose?.();

            }

        };

        document.body.style.overflow = "hidden";

        window.addEventListener(

            "keydown",

            handleKeyDown

        );

        return () => {

            document.body.style.overflow = "";

            window.removeEventListener(

                "keydown",

                handleKeyDown

            );

        };

    }, [

        open,

        onClose,

    ]);

    if (!open) {

        return null;

    }

    return createPortal(

        <>

            <div

                className={styles.backdrop}

                onClick={onClose}

            />

            <div className={styles.sheet}>

                <div className={styles.handle} />

                {

                    title &&

                    <div className={styles.header}>

                        {title}

                    </div>

                }

                <div className={styles.content}>

                    {children}

                </div>

            </div>

        </>,

        document.body

    );

};

export default BottomSheet;